import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import NormalTabs from '@ifeng-fe/three_terminal/es/mobile/tabs/normalTabs';
import InformationFlow from '@ifeng-fe/three_terminal/es/mobile/informationFlow/informationFlow';
import ViewMoreLink from '@ifeng-fe/three_terminal/es/mobile/tabs/viewMoreLink';
import styles from './index.css';

const BLOCKS = [
    { key: 'news', title: '独家原创', url: 'https://original.ifeng.com/news' },
    { key: 'finance', title: '财经信源', url: 'https://original.ifeng.com/finance' },
    { key: 'tech', title: '科技精选', url: 'https://original.ifeng.com/tech' },
];

class OriginalFeed extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const content = this.props.content || {};

        return (
            <div>
                {BLOCKS.map(item => {
                    const list = content[item.key] || [];

                    return (
                        <section className={styles.block} key={item.key} aria-label={item.title}>
                            <NormalTabs hasSticky={true} content={{ title: item.title, url: item.url, subTit: [] }} />
                            {list.length > 0 && <InformationFlow content={list} isLazyImage={true} isDisplayLoadingMore={false} />}
                            <ViewMoreLink content={{ title: '查看更多', link: item.url }} />
                        </section>
                    );
                })}
            </div>
        );
    }
}

export default errorBoundary(OriginalFeed);
